import { Component, inject, input, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CwButton } from '@bbraun/cortex-angular';
import { TranslateModule } from '@ngx-translate/core';
import { ABORT_REASON_MAX_LENGTH } from '~/app/classes/TherapyJobFormClass';
import { PersonNamePipe } from '~/app/pipes/PersonName';
import { SafeHtmlPipe } from '~/app/pipes/SafeHtml';
import { Dialog, DialogService } from '~/app/services/dialog.service';
import { TherapyJobStore } from '~/app/store/job.store';
import { TextareaComponent } from '../textarea/textarea.component';

@Component({
  selector: 'gplus-finalize-modal',
  imports: [TranslateModule, CwButton, TextareaComponent, PersonNamePipe, ReactiveFormsModule, SafeHtmlPipe],
  templateUrl: './abort-modal.component.html',
  styleUrl: './abort-modal.component.scss'
})
export class AbortModalComponent {
  public dialog = input<Dialog>();
  public jobsStore = inject(TherapyJobStore);

  public form = signal<FormGroup<{ abortReason: FormControl<string> }>>(
    new FormGroup({
      abortReason: new FormControl(null, [Validators.required, Validators.maxLength(ABORT_REASON_MAX_LENGTH)])
    })
  );

  public abortReasonMaxLength = ABORT_REASON_MAX_LENGTH;

  constructor(private readonly dialogService: DialogService) {}

  public closeDialog() {
    this.dialog().confirm.next(false);
    this.dialogService.close();
  }

  public submitChange() {
    if (this.form().dirty && this.form().valid) {
      // we patch
      this.jobsStore.patchJob({ abortReason: this.form().get('abortReason')?.value }, this.dialog().data.id);
      this.dialog().confirm.next(true);
    }
  }
}
